import m from "../../geodata/es2015/syriaLow";
window.am4geodata_syriaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/syriaLow.js
// module id = null
// module chunks = 